import {CreateEventData} from 'organization/Event/CreateEventData'

/** Only set when the user confirms “Sign in to create”; not used to restore the wizard on refresh. */
const STORAGE_KEY = 'eventatv_pending_event_draft_v1'

export function savePendingEventDraft(data: CreateEventData) {
  try {
    sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({...data, storedAt: Date.now()}),
    )
  } catch {
    // ignore
  }
}

export function peekPendingEventDraft(): CreateEventData | null {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    const p = JSON.parse(raw) as CreateEventData & {storedAt?: number}
    if (!p.name || !p.slug) return null
    return {
      name: p.name,
      slug: p.slug,
      locale: p.locale,
    }
  } catch {
    return null
  }
}

export function clearPendingEventDraft() {
  try {
    sessionStorage.removeItem(STORAGE_KEY)
  } catch {
    // ignore
  }
}
